import { Component } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';

import { GenericService } from './generic.service';


declare var window;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  homeButton = false;
  profileButton = false;
  prefaceButton = false;
  logoutButton =false;
  summary=false;
 
  postloadingAssessment=false;
  internetConnection:boolean=false;
  preloadingVerification=false;

  allow_prev_post:boolean=false;


  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menuCtrl: MenuController,
    private router: Router,
    private genericService: GenericService,
  ) {
  
    
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      window.app = this;
      
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }
  navToPage(val) {
    if (val == "1") {
      this.summary=false;

      this.homeButton = true;
      this.profileButton = false;
      this.prefaceButton = false;
      this.logoutButton =false;
      this.postloadingAssessment = false;
      this.preloadingVerification=false
      this.menuCtrl.close();
      this.router.navigateByUrl('home');

    }
    else if(val=="2"){
      this.summary=false;
      this.homeButton = false;
      this.profileButton = false;
      this.postloadingAssessment = false;
      this.preloadingVerification=true
      this.logoutButton =false;
      this.menuCtrl.close();
      this.router.navigateByUrl('preloading-verification');
    }
    else if(val=="3"){
      this.summary=false;
      this.homeButton = false;
      this.profileButton = false;
      this.postloadingAssessment = true;
      this.preloadingVerification=false
      this.prefaceButton = false;
      this.logoutButton =false;
      this.menuCtrl.close();
      this.router.navigateByUrl('postloading-list');
    }
    else if(val=="4"){
      this.summary=false;
      this.homeButton = false;
      this.profileButton = true;
      this.postloadingAssessment = false;
      this.preloadingVerification=false
      this.prefaceButton = false;
      this.logoutButton =false;
      this.menuCtrl.close();
      this.router.navigateByUrl('profile');
    }
    else if(val=="5"){
      this.summary=true;
      this.homeButton = false;
      this.profileButton = false;
      this.postloadingAssessment = false;
      this.preloadingVerification=false
      this.prefaceButton = false;
      this.logoutButton =false;
      this.menuCtrl.close();
      this.router.navigateByUrl('summary');
    }
  }
}
